import { Button, Col, Popconfirm, Row, Space, Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import Title from 'antd/lib/typography/Title';
import styled from 'styled-components';
import { styledTable } from '../styled/mixin';

const StyledDiv = styled.div`
  ${styledTable}
`;

interface VendorJigjongListComponentProps {
  data: any[];
  onDelete: (data: string) => void;
  openVendorJigjongAddModal: () => void;
}

function VendorJigjongListComponent({
  data,
  onDelete,
  openVendorJigjongAddModal,
}: VendorJigjongListComponentProps) {
  const columns: ColumnsType<any> = [
    {
      title: '용도',
      dataIndex: 'name',
      sorter: (a: any, b: any) => a.name.localeCompare(b.name),
      width: '80%',
    },
    {
      title: '',
      key: 'action',
      align: 'center',
      width: '20%',
      render: (text: string, record: any, index: number) => (
        <Space size="small">
          <div onClick={(e) => e.stopPropagation()}>
            <Popconfirm
              title="정말 삭제하시겠습니까?"
              data-test={`project-list-item-${index}`}
              onConfirm={() => onDelete(record.name)}
            >
              <Button size="small">삭제</Button>
            </Popconfirm>
          </div>
        </Space>
      ),
    },
  ];

  return (
    <StyledDiv>
      <Row justify={'space-between'}>
        <Col>
          <Title level={5}>작업자 직종 리스트</Title>
        </Col>
        <Button
          onClick={openVendorJigjongAddModal}
          size="small"
          style={{ marginRight: '30px' }}
        >
          추가
        </Button>
      </Row>
      <Row>
        <Col span={24}>
          <Table
            rowKey="name"
            columns={columns}
            dataSource={data}
            pagination={{
              defaultPageSize: 20,
              showSizeChanger: true,
              pageSizeOptions: ['10', '20', '30', '50', '100', '300'],
              position: ['bottomCenter'],
            }}
            locale={{
              triggerDesc: '내림차순으로 정렬하려면 클릭하세요.',
              triggerAsc: '오름차순으로 정렬하려면 클릭하세요.',
              cancelSort: '정렬을 취소하려면 클릭하세요.',
            }}
          />
        </Col>
      </Row>
    </StyledDiv>
  );
}

export default VendorJigjongListComponent;
